<template>
  <div class="home">
    <el-container class="home-container">

      <el-container>
        <el-header height="7rem" style="padding:0">
          <Header></Header>
        </el-header>
          <el-container style=" flex-direction: column">
              <myBreadcrumb  id="tag"  @tagBackInfo="handleInfo" style="background-color: #fff;"></myBreadcrumb>
          </el-container>
        <el-container style="background: #f0f1f3;" :style="calcMinHeght()"  class="main-container'">
            <!-- 侧边栏 -->
            <Menu />
            <router-view></router-view>
        </el-container>
<!--        <MyFooter />-->
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Menu from "@/components/menu";
import Header from "@/components/header";
import MyFooter from "@/components/myfooter";
import myBreadcrumb from  "@/components/myBreadcrumb";
import request from "../utils/request";
export default {
  name: "Home",
  components: {
    Menu,
    Header,
    MyFooter,
      myBreadcrumb,
  },
    data(){
      return{
          infos:null,
          tagsHeight:0,
      }
    },
  methods:{
      handleInfo(item,isleaf){
          if (isleaf == null) {
              this.infos = item;
              //响应式更新视图（侧边栏）
              this.$set(this.infos, 'isleaf', item.isleaf);
          }else{
              item.isleaf = isleaf;
              this.infos = item;
              //响应式更新视图（侧边栏）
              this.$set(this.infos, 'isleaf', item.isleaf);
          }

      },
      calcMinHeght() {
          setTimeout(() => {
              this.tagsHeight = document.getElementById("tag").offsetHeight;
          }, 500);
          return { height: `calc(100% - ${this.tagsHeight+"px"} - 7rem)` };
      },

  },
    watch:{
        "$store.state.tags.tabsList"() {
            setTimeout(() => {
              let tag=document.getElementById("tag");
              if (tag!==null){
                this.tagsHeight = tag.offsetHeight;
              }
            }, 500);
        },

    }
};
</script>
<style scoped lang="less">
.home {
  min-height: 100vh;
  .home-container {
    height: 100vh;
  }
}
</style>
